export const areas = [
  {
    name: "القاهرة",
    areas: [
      // الأساس
      "القاهرة",
      "المقطم",
      "مصر الجديده",
      "العاشر من رمضان",
      "بدر",
      "عين شمس",
      "جسر السويس",
      "حلمية الزيتون",
      "شيراتون مصر الجديدة",
      "المطار",
      "طريق الاسماعيليه",
      "طريق السويس",
      "الشروق",
      "مدينتي",
      "الرحاب",
      "مدينه المستقبل",
      "القطاميه",
      "التجمع الخامس",
      "التجمع الخامس مدينة نصر",
      "التجمع التالت",
      "التجمع الاول",
      "التجمع الاول مدينة نصر",
      "شارع التسعين",
      "طريق السخنه",
      "الدائري",
      "الطريق الدائري",
      "صلاح سالم",
      "طريق الاوتوستراد",
      "طريق الاوتوستراد  ",
      "صقر قريش  ",
      "طريق مصر اسكندريه الصحراوي",
      "المعادي",
      "زهراء المعادي",
      "غمره",
      "احمد سعيد",
      "الضاهر",
      "باب الشعرية",
      "الزاويه",
      "السيده زينب",
      "السيده عائشه",
      "القلعه",
      "مدينة نصر",
      "مكرم عبيد مدينة نصر",
      "عباس العقاد مدينة نصر",
      "الحي السادس مدينة نصر",
      "الحي السابع مدينة نصر",
      "الحي العاشر",
      "طريق المشير",
      "محور جيهان السادات",
      "محور محمد نجيب",
      "جمال عبدالناصر",
      "محور ٣٠ يونيو",
      "الهضبه الوسطى",
      "كورنيش المقطم",
      "المقطم",
      "وسط البلد",
      "حدائق القبة",
      "الوايلي",
      "الزيتون",
      "المطرية",
      "المرج",
      "السلام",
      "الخصوص",
      "عين حلوان",
      "حلوان",
      "كوتسيكا",
      "طرة",
      "المعصرة",
      "دار السلام",
      "البساتين",
      "منشية ناصر",
      "العباسية",
      "حدائق الزيتون",
      "الزهراء",
      "مدينة الشروق",
      "الهايكستب",
      "الماظة",
      "النزهة مصر الجديدة",
      "النزهة الجديدة",
      "هليوبوليس",
      "سانت فاتيما مصر الجديدة",
      "روكسي مصر الجديدة",
      "الكوربة",
      "الميرغني مصر الجديدة",
      "المطار القديم",
      "أرض الجولف",
      "الحلمية",
      "سراي القبة",
      "قصر القبة",
      "منشية البكري",
      "عين شمس الشرقية",
      "عين شمس الغربية",
      "شبرا",
      "شبرا مصر",
      "روض الفرج",
      "الخليفة المأمون",
      "كلية البنات مصر الجديدة",
      "جامعة عين شمس",
      "الموسكي",
      "العتبة",
      "الأزبكية",
      "رمسيس",
      "محطة مصر",
      "الفجالة",
      "سكة الوايلي",
      "التحرير",
      "عبد المنعم رياض",
      "طلعت حرب",
      "قصر النيل",
      "جاردن سيتي",
      "ماسبيرو",
      "كورنيش النيل",
      "مدينة بدر",
      "العاصمة الإدارية الجديدة",
      "الأسمرات",
      "مدينة 15 مايو",
      "حلوان الجديدة",
      "حدائق حلوان",
      "وادي حوف",
      "المعادي الجديدة",
      "المعادي هايتس",
      "جراند مول المعادي",
      "مدينة الأمل",
      "زهراء المعادي",
      " سيتي سنتر",
      "المستثمرين الشمالية",
      "المستثمرين الجنوبية",
      "التجمع الثالث",
      "القطامية",
      "طريق السخنة",
      "مصر الجديدة",
      "شيراتون",
      "النزهة",
      "العاصمة الإدارية",
      "صقر قريش",

      // كمبوندات
      "كمبوند القطامية هايتس",
      "كمبوند ستون بارك",
      "كمبوند ليان",
      "كمبوند ميفيدا",
      "كمبوند هايد بارك",
      "كمبوند ماونتن فيو",
      "كمبوند بالم هيلز القاهرة الجديدة",

      // شوارع رئيسية مشهورة
      "شارع رمسيس",
      "شارع 26 يوليو",
      "طلعت حرب",
      "قصر العيني",
      "المعز لدين الله الفاطمي",
      "الحسين",
      "الأزهر",
      "شارع النصر مدينة نصر",
      "شارع الطيران",
      "شارع يوسف عباس",
      "شارع مصطفى النحاس مدينة نصر",
      "شارع حسن المأمون مدينة نصر",
      "شارع الخليفة المأمون",
      "شارع مصر والسودان",
      "شارع شبرا",
      "شارع الساحل",
      "شارع بورسعيد",
      "كورنيش المعادي المعادي",
      "ميدان الجزائر المعادي",
      "دجلة المعادي",
      "كارفور المعادي المعادي",
      "ثكنات المعادي المعادي",
      "اوتوستراد المعادي المعادي",
      "شارع ٧ المعادي",
      "القمر الصناعي المعادي",
      "كورنيش حلوان",
      "شارع 9 المعادي",
      "الجامعة الأمريكية",
      "شارع التسعين الشمالي",
      "شارع التسعين الجنوبي",
      "شارع الثورة مصر الجديدة",
      "شارع العروبة",
      "شارع النزهة مصر الجديدة",
      "شارع عثمان بن عفان",
      "شارع بيروت",
      "شارع بغداد",
      "شارع هارون الرشيد مصر الجديدة",
      "شارع الحجاز مصر الجديدة",
      "شارع عمر بن الخطاب",
      "شارع جسر السويس",
      "المفارق",
      "شارع ٩",
      "شارع صبحي حسين",
      "ميدان النافورة",
      "ابتاون كايرو",
      "كريم بنونه",
      "شارع ١٧",
      "الهضبه العليا",
      "الهضبه السفلى",
      "كوبري حسبالله الكفراوي",
      "الاسمرات",
      "محور كمال عامر",
      "محور عمرو بن العاص",
      "امتداد رمسيس",
      "الدراسه",
      "الجماليه",
      "طريق النصر",
      "الحي الثامن مدينة نصر",
      "الوفاء والامل",
      "كايرو فيستيفال",
      "مدينة القاهرة الجديدة",
      "طريق الشهيد",
      "طريق بلبيس",
      "الفسطاط",
      "كورنيش المعادي",
      "طره",
      "حدائق حلوان",
      "الحوامدية",
      "سقاره",
      "دهشور",
      "الطريق الابيض",
      "ابو رواش",
      "العياط",
      "الصف",
      "اطفيح",
      "طريق اسيوط القاهرة الصحراوي",
      "كرداسه مدينة الجيزة",
      "صفط اللبن مدينة الجيزة",
      "ارض اللواء",
      "باسوس",
      "عبود",
      "بهتيم",
      "الخصوص",
      "عزبة النخل",
      "ميدان ابن الحكم",
      "ميدان الجامع مصر الجديدة",
      "يوسف عباس",
      "مصطفى النحاس مدينة نصر",
      "ميدان روكسي مصر الجديدة",
      "كوبري الحلميه",
      "أحمد عصمت عين شمس",
      "الف مسكن",
      "محور المشير علي فهمي",
      "اسكان الشباب",
      "البنفسج",
      "الهايكستب",
      "شارع المقطم",
    ],
  },
  {
    name: "الجيزة",
    areas: [
      "الجيزة",
      "المهندسين",
      "المريوطيه",
      "الهرم",
      "العجوزه",
      "كرداسه  ",
      "الدقي  ",
      "ميدان الدقي  ",
      "العمرانية  ",
      "ترسا  ",
      "الطالبيه  ",
      "التعاون  ",
      "مدينة الجيزة",
      "زايد",
      "اكتوبر",
      "المحور",
      "حدائق الاهرام",
      "فيصل",
      "المريوطية",
      "مشعل",
      "حدائق اكتوبر",
      "طريق الفيوم",
      "طريق الواحات",
      "٦ اكتوبر",
      "أكتوبر",
      "الشيخ زايد",
      "الزمالك",
      "الوراق",
      "عابدين",
      "شبرا",
      "شبرا الخيمه",
      "كورنيش النيل",
      "نيو جيزه",
      "امبابه ",
      "المطبعة ",
      "الرماية",
      "ميدان الرماية",
      "البحر الأعظم",
      "شارع مراد ",
      "أرض اللواء",
      "المنصورية",
      "طريق المنصورية",
      "مول مصر",
      "هايبر وان",
      "القرية الذكية",
      "مدينة الشيخ زايد",
      "beverly Hills",
      "كمبوند زايد 2000",
      "كمبوند جراند هايتس",
      "كمبوند رويال سيتي",
      "كمبوند ويست تاون",
      "كمبوند الكرمة",
      "كمبوند جاليريا مون فالي",
      "كمبوند اليجريا",
      "كمبوند سوديك ويست",
      "كمبوند بيفرلي هيلز زايد",
      "حدائق الشيخ زايد",
      "ميدان لبنان ",
      "شارع جامعة الدول العربية ",
      "جامعة القاهرة",
      "شارع التحرير مدينة الجيزة",
      "ميدان النهضة",
      "شارع الهرم ",
      "شارع فيصل ",
      "ميدان الجيزة ",
      "المنيب",
      "ساقية مكي",
      "كفر طهرمس",
      "نصر الدين ",
      "خاتم المرسلين ",
      "الحسن محمد ",
      "اللبيني ",
      "كفر طهرمس ",
      "شارع العشرين ",
      "البحر الأعظم ",
      "شارع البحر الأعظم ",
      "شارع وادي النيل ",
      "ميدان سفنكس ",
      "احمد عرابي ",
      "البحوث ",
      "القريه الفرعونية ",
      "المنشيه ",
      "الطوابق  ",
      "بولاق الدكرور  ",
      "صفط اللبن  ",
      "أبو رواش",
      "الحوامدية",
      "البدرشين",
      "العياط",
      "الصف",
      "أطفيح",
      "الواحات البحرية",
    ],
  },
  {
    name: "الإسكندرية",
    areas: [
      "الإسكندرية",
      "كوم الدكة",
      "الشاطبي",
      "الأنفوشي",
      "رأس التين",
      "بحري",
      "المكس",
      "القباري",
      "كرموز",
      "الورديان",
      "الكورنيش",
      "محطة الرمل",
      "ميامي",
      "العصافره",
      "سموحه",
      "ستانلي",
      "جليم",
      "زيزينيا",
      "سيدي بشر",
      "العجمي",
      "الهانوفيل",
      "أبو قير",
      "المعمورة",
      "برج العرب",
      "المنتزه",
      "سان ستيفانو",
      "كامب شيزار",
      "سبورتنج",
      "سيدي جابر",
      "رمل اول",
      "رمل تاني",
      "باكوس",
      "غيط العنب",
      "ميدان محطة مصر",
      "ميدان المنشية",
      "ميدان الساعة",
      "جامعة الإسكندرية",
      "قلعة قايتباي",
      "مكتبة الإسكندرية",
      "المعمورة البلد",
      "المعمورة الشاطئ",
      "كفر عبده",
      "الابراهيمية",
      "النزهة",
      "بولكلي",
      "فلمنج",
      "جناكليس",
      "لوران",
      "رشدي",
      "مدينة برج العرب الجديدة",
      "العامرية",
      "الهانوفيل البحرية",
      "الحضرة",
      "شدس",
      "جليم باي",
      "سيدي كرير",
      "العلمين الجديدة",
      "الساحل الشمالي",
    ],
  },
  {
    name: "القليوبية",
    areas: [
      "شبرا الخيمة",
      "بنها",
      "قليوب",
      "قها",
      "طوخ",
      "الخانكة",
      "العبور",
      "الخصوص",
      "كفر شكر",
      "جامعة بنها",
      "كورنيش بنها",
      "طريق القاهرة – الإسكندرية الزراعي",
      "ميدان المؤسسة",
      "شارع 15 مايو شبرا الخيمة",
    ],
  },
  {
    name: "الدقهلية",
    areas: [
      "المنصورة",
      "طلخا",
      "ميت غمر",
      "دكرنس",
      "أجا",
      "منية النصر",
      "السنبلاوين",
      "الكردي",
      "بني عبيد",
      "المنزلة",
      "تمي الأمديد",
      "الجمالية",
      "شربين",
      "المطرية",
      "بلقاس",
      "ميت سلسيل",
      "جمصة",
      "محلة دمنة",
      "نبروه"
    ]
  },
  {
    name: "الشرقية",
    areas: [
      "الزقازيق",
      "العاشر من رمضان",
      "بلبيس",
      "مشتول السوق",
      "القنايات",
      "أبو حماد",
      "القرين",
      "ههيا",
      "أبو كبير",
      "فاقوس",
      "الصالحية الجديدة",
      "كفر صقر",
      "أولاد صقر",
      "الحسينية",
      "صان الحجر القبلية",
      "منيا القمح",
      "ديرب نجم",
      "الإبراهيمية"
    ]
  },
  {
    name: "المنوفية",
    areas: [
      "شبين الكوم",
      "منوف",
      "أشمون",
      "الباجور",
      "قويسنا",
      "بركة السبع",
      "تلا",
      "الشهداء",
      "سرس الليان",
      "السادات"
    ]
  },
  {
    name: "الغربية",
    areas: [
      "طنطا",
      "المحلة الكبرى",
      "كفر الزيات",
      "زفتى",
      "السنطة",
      "قطور",
      "بسيون",
      "سمنود"
    ]
  },
  {
    name: "كفر الشيخ",
    areas: [
      "كفر الشيخ",
      "دسوق",
      "فوه",
      "مطوبس",
      "بلطيم",
      "الرياض",
      "سيدي سالم",
      "بيلا",
      "الحامول",
      "قلين"
    ]
  },
  {
    name: "البحيرة",
    areas: [
      "دمنهور",
      "كفر الدوار",
      "رشيد",
      "إدكو",
      "أبو المطامير",
      "أبو حمص",
      "الدلنجات",
      "المحمودية",
      "الرحمانية",
      "إيتاي البارود",
      "حوش عيسى",
      "شبراخيت",
      "كوم حمادة",
      "بدر",
      "وادي النطرون",
      "النوبارية الجديدة"
    ]
  },
  {
    name: "دمياط",
    areas: [
      "دمياط",
      "رأس البر",
      "فارسكور",
      "الزرقا",
      "السرو",
      "الروضة",
      "كفر سعد",
      "عزبة البرج",
      "ميت أبو غالب"
    ]
  },
  {
    name: "بورسعيد",
    areas: [
      "بورسعيد",
      "بورفؤاد",
      "العرب",
      "الزهور",
      "الشرق",
      "الضواحي",
      "المناخ",
      "مبارك"
    ]
  },
  {
    name: "الإسماعيلية",
    areas: [
      "الإسماعيلية",
      "فايد",
      "القنطرة شرق",
      "القنطرة غرب",
      "التل الكبير",
      "أبو صوير",
      "القصاصين الجديدة",
      "نفيشة"
    ]
  },
  {
    name: "السويس",
    areas: [
      // أحياء رئيسية
      "حي السويس",
      "حي الأربعين",
      "حي عتاقة",
      "حي الجناين",
      "حي فيصل",

      // مناطق داخل حي السويس
      "بور توفيق",
      "الملاحة",
      "الفرز",
      "الخالدين",
      "الأنصاري",
      "الكورنيش",

      // مناطق داخل حي الأربعين
      "الألبان القديمة",
      "الألبان الجديدة",
      "مدينة السلام 1",
      "مدينة السلام 2",
      "الـ24 أكتوبر",
      "الكبانون",
      "المثلث",
      "الهويس",

      // مناطق داخل حي فيصل
      "مدينة التوفيق",
      "الرحاب",
      "الشباب",
      "الإيمان",
      "النهضة",
      "الحرية",
      "التعاونيات",
      "الإسكان الاجتماعي",

      // مناطق داخل حي عتاقة
      "الأدبية",
      "السخنة",
      "العين السخنة",
      "عتاقة البلد",
      "المدينة الصناعية",
      "المنطقة الحرة",
      "السويس الجديدة",
      "طريق الجلالة",
      "هضبة الجلالة",
      "راس سدر",
      "ابورديس",
      "عيون موسى",
      "نفق الشهيد احمد حمدى",
      "نويبع",
      "طابا",
      "دهب",
      "شرم الشيخ",
      "الطور",
      "حنوب سيناء",
      "العريش",
      // مناطق داخل حي الجناين
      "قرية عامر",
      "قرية العمدة",
      "قرية الشلوفة",
      "كبريت",
      "أبو سيال",
      "الجبلايات",

      // مناطق ومجتمعات جديدة
      "مدينة السلام",
      "مدينة النور",
      "السويس الجديدة",
      "دار مصر",
      "الإسكان المتميز",
      "ميناء السويس ",
      "ميناء السخنة ",
      "ميناء نويبع",
      "طريق جنيفة",
      "عجرود ",
      "محور 30 يوليو",
      "طريق الادبية",
      "طريق السويس",
      "طريق القاهره السويس",
      "بورتو السخنة ",
      "طريق الزعفرانة بني سويف",
      "وادي حجول طريق السويس",
      "ام قمر طريق السويس",
      "جامعة الجلالة",
      "طريق الإقليمي",
      "الاتكة",
      "الغريب",
      "المونت جلالة",
      "الشركة الصينية",
      "طريق الجلالة الجديد",
      "طريق السخنة ",
      "الزعفرانة",
      "اميجو العين السخنة",
      "راس شقير",
      "طريق راس غارب",
      "راس سدر",
      " البحر الاحمر ",
      "ميناء سفاجا",
      "ابوزنيمية جنوب سيناء",
      "صدر حيطان",
      "النقب",
      "طريق السخنة الزعفرانة",
      " سيارات السويس",
      " المستقبل في السويس ",
      "جمرك السويس",
      " فايد",
      "قرية ساند بيتش",
      " طريق المحاجر العين السخنة",


    ]
  },
  {
    name: "شمال سيناء",
    areas: [
      "العريش",
      "الشيخ زويد",
      "نخل",
      "رفح",
      "بئر العبد",
      "الحسنة"
    ]
  },
  {
    name: "جنوب سيناء",
    areas: [
      "الطور",
      "شرم الشيخ",
      "دهب",
      "نويبع",
      "طابا",
      "سانت كاترين",
      "أبو رديس",
      "أبو زنيمة",
      "رأس سدر"
    ]
  },
  {
    name: "البحر الأحمر",
    areas: [
      "الغردقة",
      "سفاجا",
      "القصير",
      "مرسى علم",
      "رأس غارب",
      "الشلاتين",
      "حلايب"
    ]
  },
  {
    name: "الفيوم",
    areas: [
      "الفيوم",
      "سنورس",
      "طامية",
      "إبشواي",
      "إطسا",
      "يوسف الصديق",
      "الفيوم الجديدة"
    ]
  },
  {
    name: "بني سويف",
    areas: [
      "بني سويف",
      "بني سويف الجديدة",
      "الواسطى",
      "ناصر",
      "إهناسيا",
      "ببا",
      "الفشن",
      "سمسطا",
      "الإباصيرية"
    ]
  },
  {
    name: "المنيا",
    areas: [
      "المنيا",
      "المنيا الجديدة",
      "العدوة",
      "مغاغة",
      "بني مزار",
      "مطاي",
      "سمالوط",
      "المدينة الفكرية",
      "ملوي",
      "دير مواس",
      "أبو قرقاص"
    ]
  },
  {
    name: "أسيوط",
    areas: [
      "أسيوط",
      "أسيوط الجديدة",
      "ديروط",
      "منفلوط",
      "القوصية",
      "أبنوب",
      "أبو تيج",
      "الغنايم",
      "ساحل سليم",
      "البداري",
      "صدفا"
    ]
  },
  {
    name: "سوهاج",
    areas: [
      "سوهاج",
      "سوهاج الجديدة",
      "أخميم",
      "البلينا",
      "المراغة",
      "المنشأة",
      "دار السلام",
      "جرجا",
      "جهينة",
      "ساقلته",
      "طما",
      "طهطا",
      "العسيرات"
    ]
  },
  {
    name: "قنا",
    areas: [
      "قنا",
      "قنا الجديدة",
      "أبو تشت",
      "نجع حمادي",
      "دشنا",
      "الوقف",
      "قفط",
      "نقادة",
      "فرشوط",
      "قوص"
    ]
  },
  {
    name: "الأقصر",
    areas: [
      "الأقصر",
      "الأقصر الجديدة",
      "إسنا",
      "الطود",
      "الزينية",
      "البياضية",
      "القرنة",
      "أرمنت",
      "الكرنك",
      "طيبة الجديدة"
    ]
  },
  {
    name: "أسوان",
    areas: [
      "أسوان",
      "أسوان الجديدة",
      "دراو",
      "كوم أمبو",
      "نصر النوبة",
      "كلابشة",
      "إدفو",
      "الرديسية",
      "البصيلية",
      "السباعية",
      "أبو سمبل السياحية"
    ]
  },
  {
    name: "مطروح",
    areas: [
      "الضبعة",
      "النجيلة",
      "سيدي براني",
      "السلوم",
      "سيوة",
      "الساحل الشمالي",
      "الحمام",
      "العلمين",
      "مدينة العلمين الجديدة",
      "سيدي عبد الرحمن",
      "سيدي حنيش",
      "مراسي",
      "مراقيا",
      "بورتو مارينا",
      "مارينا 1",
      "مارينا 2",
      "مارينا 3",
      "مارينا 4",
      "مارينا 5",
      "مارينا 6",
      "مارينا 7",
      "لا فيستا",
      "لافيستا باي",
      "هاسيندا باي",
      "هاسيندا وايت",
      "هاسيندا ريد",
      "هاسيندا ويست",
      "سي شيلز",
      "سيزر",
      "سيزر أيلاند",
      "فوكا",
      "فوكا باي",
      "فوكا الجديدة",
      "جيفيرا",
      "ماونتن فيو",
      "ماونتن فيو رأس الحكمة",
      "رأس الحكمة",
      "غزالة باي",
      "غزالة فالي",
      "غزالة الساحل",
      "أمواج",
      "الضبعة",
      "كالي كوست",
      "بلو باي",
      "بالم هيلز العلمين",
      "مرسى مطروح"
    ]
  },
  {
    name: "الوادي الجديد",
    areas: [
      "الخارجة",
      "باريس",
      "موط",
      "الفرافرة",
      "بلاط",
      "الداخلة"
    ]
  }
];